"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersService = void 0;
class CustomersService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Create a customer in stripe
     * @returns CustomerResponseDto
     * @throws ApiError
     */
    postCustomersCreate({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Add a payment method in stripe
     * @returns CustomerResponseDto
     * @throws ApiError
     */
    postCustomersPaymentMethod({ customerId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/payment-method',
            path: {
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * update a payment method in stripe
     * @returns CustomerResponseDto
     * @throws ApiError
     */
    putCustomersPaymentMethod({ customerId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/customers/{customerId}/payment-method',
            path: {
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * get a list of payment methods for a customer
     * @returns PaymentMethodResponseDto
     * @throws ApiError
     */
    getCustomersPaymentMethod({ customerId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customers/{customerId}/payment-method',
            path: {
                'customerId': customerId,
            },
        });
    }
    /**
     * Create a customer in stripe
     * @returns CustomerResponseDto
     * @throws ApiError
     */
    postCustomersSetupIntent({ customerId, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/setup-intent',
            path: {
                'customerId': customerId,
            },
        });
    }
    /**
     * Get subscription for a customer
     * @returns SubscriptionResponseDto
     * @throws ApiError
     */
    getCustomersGetSubscription({ scheduleSubscriptionId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customers/{scheduleSubscriptionId}/get-subscription',
            path: {
                'scheduleSubscriptionId': scheduleSubscriptionId,
            },
        });
    }
    /**
     * Subscribe customer to plan
     * @returns SubscribeToPlanResponseDto
     * @throws ApiError
     */
    postCustomersSubscribeToPlan({ customerId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/subscribe-to-plan',
            path: {
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Subscribe customer to plan
     * @returns any
     * @throws ApiError
     */
    postCustomersCancelSubscriptions({ customerId, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/cancel-subscriptions',
            path: {
                'customerId': customerId,
            },
        });
    }
    /**
     * Change customer plan subscribed (using Subscription Schedules, removing any future phase)
     * @returns PaymentMethodResponseDto
     * @throws ApiError
     */
    postCustomersChangePlan({ customerId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/change-plan',
            path: {
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update email customer
     * @returns CustomerResponseDto
     * @throws ApiError
     */
    postCustomersUpdateEmailBilling({ customerId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers/{customerId}/update-email-billing',
            path: {
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.CustomersService = CustomersService;
